export const NOTIFICATION_POLL_INTERVAL =
  Number(
    // VITE_NOTIFICATION_POLL_INTERVAL is in min and converted to ms here for use in the app
    import.meta.env.VITE_NOTIFICATION_POLL_INTERVAL ?? 0.5,
  ) *
  60 *
  1000

export const AU_STATES = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'NT', 'ACT'] as const

export const APPLICATION_STATUSES = ['new', 'taken', 'accepted', 'approved', 'settled', 'rejected'] as const

export const ALLOWED_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'] as const
export const MAX_FILE_SIZE_MB = 10
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

// ExpenseColumn type — the string union of all expense category keys.
// Values are sourced from the backend (Expense::MONTHLY_COST_COLUMNS) and passed as props.
export type ExpenseColumn =
  | 'housing'
  | 'groceries'
  | 'transportation'
  | 'clothing'
  | 'utilities'
  | 'subscriptions'
  | 'entertainment'
  | 'education'
  | 'rent'
  | 'medical'
  | 'insurance'
  | 'communication'
